import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { FAQS } from "../../data/site";
import { scrollToId } from "../../lib/contact";

export const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-28 bg-background">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHead
          align="center"
          overline="FAQ"
          title="Questions, Answered Honestly"
          sub="Everything students and parents usually ask before joining."
        />
        <div className="mt-12 space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={f.q} delay={Math.min(i * 0.03, 0.15)}>
                <div
                  data-testid={`faq-item-${i + 1}`}
                  className={`bg-white rounded-xl border transition-colors ${isOpen ? "border-electric/50" : "border-slate-200/80"}`}
                >
                  <button
                    data-testid={`faq-trigger-${i + 1}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
                  >
                    <span className="font-display font-semibold text-navy text-sm sm:text-base">{f.q}</span>
                    <Plus size={18} className={`shrink-0 text-electric transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`} />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="px-6 pb-6 text-sm text-slate-500 leading-relaxed">{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={0.1} className="mt-10 text-center">
          <button
            data-testid="faq-cta"
            onClick={() => scrollToId("contact")}
            className="group inline-flex items-center gap-2 text-sm font-semibold text-electric hover:text-electric-dark"
          >
            Still have a question? Book Free Counselling
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </Reveal>
      </div>
    </section>
  );
};
